import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  ContentWrapperStyles,
} from "./articles-suggestions-styles"

export const SectionWrapper = styled.section`
  display: flex;
  padding: 40px 0;
  ${SectionWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  ${ContentWrapperStyles}
`
